// import { getDocument, GlobalWorkerOptions, version } from "pdfjs-dist";
import mammoth from "mammoth";
// import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// pdfjsLib.GlobalWorkerOptions.workerSrc =
//   "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.313/pdf.worker.min.js";

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";
const { getDocument } = pdfjsLib;

async function extractPdf(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await getDocument({ data: arrayBuffer }).promise;

  let textContent = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const text = await page.getTextContent();
    text.items.forEach((item) => {
      if ("str" in item) textContent += item.str + " ";
    });
  }

  return textContent.trim();
}

async function extractDocx(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const { value } = await mammoth.extractRawText({ arrayBuffer });
  return value.trim();
}

export async function extractText(file: File): Promise<string> {
  const name = file.name.toLowerCase();

  if (name.endsWith(".pdf")) {
    return extractPdf(file);
  } else if (name.endsWith(".docx")) {
    return extractDocx(file);
  } else {
    throw new Error("Unsupported file type. Only PDF and DOCX are allowed.");
  }
}
